/* ============================================================================
   Shop the Look — לוגיקת הקרוסלה
   נוצר 27.7.2026. מלווה את sections/shop-the-look.liquid ואת
   assets/pg-shop-the-look.css.

   הערות מימוש חשובות:

   1) ניווט חסין-RTL. לא נשענים על הסימן או הטווח של scrollLeft: בקונטיינר עם
      direction:rtl הם אינם אחידים בין מנועי דפדפן (כרום נותן 0 עד ערך שלילי,
      מנועים אחרים נתנו היסטורית טווחים אחרים) — באג מוכר וקשה לאבחון. כל
      החישובים נעשים גיאומטרית דרך getBoundingClientRect, וההזזה היא יחסית
      בלבד. ראו את ההערה המפורטת מעל goTo().

   2) השבתת החצים נגזרת ממיקום הגלילה בפועל ולא מאינדקס הסלייד — ראו את
      ההערה בתוך sync(). זה נדרש כי עם scroll-snap-align:center הסלייד
      הראשון והאחרון לעולם אינם מגיעים באמת למרכז.

   3) וידאו: preload="none" + poster, וההפעלה נעשית רק כשהסלייד באמת נראה
      (IntersectionObserver), ומושהית כשיוצא מהמסך. כך שסקשיין עם 8 סרטונים
      לא מוריד 8 קבצי וידאו בטעינת דף הבית. מכובד גם
      prefers-reduced-motion.

   4) האזנה ל-shopify:section:load כדי שהסקשיין יעבוד מיד בעורך הנושאים
      אחרי הוספה/שינוי, בלי רענון ידני.
   ============================================================================ */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.getAttribute('data-pgstl-ready') === '1') return;
    root.setAttribute('data-pgstl-ready', '1');

    var track = root.querySelector('[data-pgstl-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-pgstl-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pgstl-dot]'));
    var prevBtn = root.querySelector('[data-pgstl-prev]');
    var nextBtn = root.querySelector('[data-pgstl-next]');
    var live = root.querySelector('[data-pgstl-live]');

    if (!slides.length) return;

    var prefersReduce =
      !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    /* --- איתור הסלייד הנוכחי לפי גיאומטריה, לא לפי scrollLeft --- */
    function currentIndex() {
      var box = track.getBoundingClientRect();
      var center = box.left + box.width / 2;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var r = slides[i].getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - center);
        if (d < bestDist) {
          bestDist = d;
          best = i;
        }
      }
      return best;
    }

    /* --- מעבר לסלייד ---
       יעד הגלילה מחושב כהיסט יחסי מתוך getBoundingClientRect ולא מתוך
       scrollLeft ישירות. זה מכוון: בקונטיינר עם direction:rtl הסימן והטווח
       של scrollLeft אינם אחידים בין מנועי דפדפן (כרום נותן 0 עד ערך שלילי,
       מנועים אחרים נתנו היסטורית טווחים אחרים) — באג מוכר וקשה לאבחון.
       לעומת זאת הכלל הבא נכון בכל מנוע ובכל כיוון: הגדלת scrollLeft ב-delta
       מזיזה את התוכן ב-delta פיקסלים שמאלה על המסך. לכן מחשבים כמה פיקסלים
       צריך להזיז (delta) ומוסיפים אותו לערך הנוכחי, בלי שום הנחה על הסימן.

       ההנפשה עצמה נעשית על ידי הדפדפן (behavior:'smooth'), שיודע לשלב אותה
       נכון עם scroll-snap. במצב prefers-reduced-motion, או כשהלשונית מוסתרת
       (דפדפנים מקפיאים אנימציות גלילה בלשונית שאינה גלויה, וגלילה חלקה פשוט
       לא תתרחש), עוברים לקפיצה מיידית כדי שהניווט לא "ייתקע". */
    function goTo(i) {
      if (i < 0) i = 0;
      if (i > slides.length - 1) i = slides.length - 1;
      var target = slides[i];
      if (!target) return;

      var tr = track.getBoundingClientRect();
      var sr = target.getBoundingClientRect();
      var delta = sr.left + sr.width / 2 - (tr.left + tr.width / 2);
      if (Math.abs(delta) < 1) return;

      var end = track.scrollLeft + delta;
      var instant = prefersReduce || document.hidden;

      if (track.scrollTo) {
        try {
          track.scrollTo({ left: end, behavior: instant ? 'auto' : 'smooth' });
        } catch (err) {
          track.scrollLeft = end;
        }
      } else {
        track.scrollLeft = end;
      }
      if (instant) sync();
    }

    function sync() {
      /* כשכל הסליידים נכנסים ברוחב המסך (למשל 4 כרטיסים צרים בדסקטופ רחב)
         אין מה לגלול. במצב הזה החצים והנקודות מוסתרים לגמרי: אחרת הם
         נראים לחיצים אבל לא עושים כלום, והנקודה הפעילה מסמנת את הכרטיס האמצעי
         (הקרוב ביותר למרכז) — מה שנראה כמו תקלה. */
      var canScroll = track.scrollWidth > track.clientWidth + 1;
      root.classList.toggle('pgstl--no-scroll', !canScroll);

      var i = currentIndex();
      for (var j = 0; j < dots.length; j++) {
        var on = canScroll ? j === i : j === 0;
        dots[j].classList.toggle('is-active', on);
        dots[j].setAttribute('aria-current', on ? 'true' : 'false');
      }
      /* השבתת החצים נגזרת ממיקום הגלילה בפועל ולא מאינדקס הסלייד. הסיבה:
         עם scroll-snap-align:center הסלייד הראשון והאחרון לעולם לא מגיעים
         באמת למרכז (הם נבלמים בקצה), ולכן currentIndex() לא מחזיר 0 או
         את האחרון גם כשהגלילה בקצה. Math.abs מטפל בשני הכיוונים: בתחילת
         הגלילה scrollLeft הוא 0 גם ב-RTL וגם ב-LTR. */
      var maxScroll = track.scrollWidth - track.clientWidth;
      var pos = Math.abs(track.scrollLeft);
      if (prevBtn) prevBtn.disabled = !canScroll || pos <= 2;
      if (nextBtn) nextBtn.disabled = !canScroll || pos >= maxScroll - 2;
      if (live) live.textContent = canScroll ? (i + 1) + ' / ' + slides.length : '';
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(currentIndex() - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(currentIndex() + 1);
      });
    }
    for (var d = 0; d < dots.length; d++) {
      (function (idx) {
        dots[idx].addEventListener('click', function () {
          goTo(idx);
        });
      })(d);
    }

    var scrollTimer;
    track.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(sync, 90);
      },
      { passive: true }
    );
    window.addEventListener('resize', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(sync, 150);
    });

    sync();

    /* --- הרחבת רשימת המוצרים --- */
    var moreBtns = root.querySelectorAll('[data-pgstl-more]');
    for (var m = 0; m < moreBtns.length; m++) {
      moreBtns[m].addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var btn = e.currentTarget;
        var wrap = btn.parentNode;
        while (wrap && !(wrap.getAttribute && wrap.getAttribute('data-pgstl-products') !== null)) {
          wrap = wrap.parentNode;
        }
        if (!wrap) return;
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var label = btn.querySelector('[data-pgstl-more-label]');
        if (label) {
          label.textContent = open
            ? btn.getAttribute('data-label-less') || ''
            : btn.getAttribute('data-label-more') || '';
        }
      });
    }

    /* --- הפעלה/השהיה של סרטונים לפי נראות --- */
    var videos = root.querySelectorAll('video[data-pgstl-video]');
    if (!videos.length) return;

    if (prefersReduce) return;

    if (!('IntersectionObserver' in window)) {
      // דפדפן ישן: פשוט מנגנים הכל. עדיף על סרטונים קפואים.
      for (var v0 = 0; v0 < videos.length; v0++) {
        var pAll = videos[v0].play();
        if (pAll && pAll.catch) pAll.catch(function () {});
      }
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          var vid = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            var p = vid.play();
            if (p && p.catch) p.catch(function () {});
          } else if (!vid.paused) {
            try {
              vid.pause();
            } catch (err) {}
          }
        }
      },
      { threshold: [0, 0.5, 1] }
    );

    for (var vi = 0; vi < videos.length; vi++) {
      io.observe(videos[vi]);
    }
  }

  function boot(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    var nodes = scope.querySelectorAll('[data-pgstl]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    // כשהאירוע מגיע מהעורך, ה-target עצמו עשוי להיות עטיפת הסקשיין
    if (scope !== document && scope.getAttribute && scope.getAttribute('data-pgstl') !== null) {
      init(scope);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
